module.exports = __webpack_public_path__ + "img/spinning.d950a31a.svg";